module.exports = __webpack_public_path__ + "static/media/SweetMix1.a0493449.png";